import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { DataService } from "./data.service"
import { Subject } from 'rxjs';
import { WidgetConfig } from "../../../class/widget-config";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: 'widget-area-chart',
  templateUrl: './widget-area-chart.component.html',
  styleUrls: ['./widget-area-chart.component.scss'],
  providers: [DataService]
})
export class WidgetAreaChartComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions = HSET.chartData;
  errorMessage = "";
  mockChart = null;
  loadingChart = true;
  errorLoadingChart = false;

  constructor(
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private dataService: DataService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService

  ) { }

  ngOnChanges(changes: SimpleChanges) {
      this.getData();
  }

  ngOnInit() {
    this.broadcaster.listen("PAGE_WIDGET_DATA").pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.setWidgetData();
    });
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.WIDGETCONFIG.id) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOptions) {
      if (this.chartOptions.series.length > 2) {
        this.chartOptions.series[2].data = [];
      }
      for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[2].data.push(t);
      }
    }
  }
  getData() {
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.errorLoadingChart = false;

    this.dataService.getData(this.WIDGETCONFIG.api, this.WIDGETCONFIG, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          this.loadingChart = false;

          if (chartData) {
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.CHARTCONFIG
            );
            this.setWidgetData();
          } else {
            this.handleError("ERROR_MSG.NO_DATA");
          }
        },
        error => {
          this.loadingChart = false;

          this.handleError("ERROR_MSG.NO_DATA");
        }
      );
  }
  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: HSET.chartData, width: 12 }];

  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
